import { render } from "./App.vue?vue&type=template&id=a0f3d642"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=a0f3d642&lang=scss"

import exportComponent from "/Users/hunterlarco/Documents/code/letter-boxed/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__